import {parseParams} from '@/common/helpers/params'

export default {

    namespaced: true,

    state: {
        params: {},
        selected: []
    },

    getters: {

        isSelected (state, getters) {
            return id => getters.selectedDeals.find(deal => deal.id === id);
        },

        selectedDeals (state) {
            return state.selected.reduce((result, b) => {
                let building = {...b};
                delete building.deals;
                b.deals.forEach(d => result.push({...d, building}));
                return result;
            }, []);
        },

        selectedQuery (state) {
            return state.selected.reduce((query, building) => {
                query[building.id] = building.deals.map(deal => deal.id);
                return query;
            }, {});
        },

        params ({params}) {
            return parseParams(params);
        }

    },

    mutations: {

        deselect (state) {
            state.selected = [];
        },

        setParams (state, params) {
            state.params = params;
        }

    },

    actions: {

        select ({state, getters}, {deal, building}) {
            const exists = state.selected.find(b => b.id === building.id);
            const isFull = getters.selectedDeals.length >= 5;
            if (exists) {
                const index = exists.deals.findIndex(d => d.id === deal.id);
                if (index !== -1) {
                    exists.deals.splice(index, 1);
                    if (!exists.deals.length) state.selected.splice(state.selected.indexOf(exists), 1)
                }
                else if (!isFull) {
                    exists.deals.push(deal);
                }
            }
            else if (!isFull) {
                state.selected.push({
                    ...building,
                    deals: [deal]
                });
            }
        }

    }

}
